import React from "react";
import GuardAvatar from "../../guarding/components/roster/GuardAvatar";
import { MAROON, MAROON_TINT } from "../../../components/common/brandColors";

const formatDay = (iso) =>
  iso ? new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : null;

// One assigned technician: real employee photo where there is one, a tinted
// icon avatar where there isn't, name bold, code muted, and the assignment
// date as a maroon pill on the right.
//
// AssignedDate is a SQL `date` column, so it is rendered as a day with no
// time - printing "12:00 AM" next to it would be invented precision, the same
// bug the History timeline had.
//
// The photo endpoint streams behind bearer auth, so GuardAvatar's blob-fetch
// is the only way to show it. The assignment record carries no hasPhoto flag
// (unlike the roster candidate list, which does), so the request is attempted
// and falls back silently to the icon - fine for the one to three technicians
// on a job, and not something to copy into a long list without a flag.
const TechnicianTile = ({ technician }) => {
  const name = `${technician.employeeFirstName || ""} ${technician.employeeLastName || ""}`.trim() || "Unnamed";
  const assignedOn = formatDay(technician.assignedDate);

  return (
    <div
      className="d-flex align-items-center p-2 mb-2 rounded"
      style={{ border: `1px solid ${MAROON}20`, background: "#fff" }}
    >
      <div className="me-2 flex-shrink-0">
        <GuardAvatar employeeRecordGuid={technician.employeeRecordGuid} hasPhoto />
      </div>
      <div className="flex-grow-1 min-width-0">
        <div className="fw-semibold text-truncate" style={{ fontSize: 13.5 }}>{name}</div>
        <div className="text-muted" style={{ fontSize: 11.5 }}>
          Code {technician.employeeCode}
          {technician.assignedByName ? ` · by ${technician.assignedByName}` : ""}
        </div>
      </div>
      {assignedOn && (
        <span
          className="badge flex-shrink-0"
          style={{ background: MAROON_TINT, color: MAROON, fontWeight: 700 }}
          title="Assigned on"
        >
          {assignedOn}
        </span>
      )}
    </div>
  );
};

export default TechnicianTile;
